import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';

type dialogData = {input: {title: string, label: string}, subject: Subject<string>};

@Component({
  selector: 'app-record-creation-modal',
  templateUrl: './record-creation-modal.component.html',
  styleUrls: ['./record-creation-modal.component.css']
})
export class RecordCreationModalComponent implements OnInit {

  @Input() title: string;
  @Input() label: string;

  record = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: dialogData, 
    public dialogRef: MatDialogRef<RecordCreationModalComponent>) { }

  ngOnInit() {
    this.title = this.data.input.title;
    this.label = this.data.input.label;
  }

  saveSignal() {
    this.data.subject.next(this.record);
    this.dialogRef.close();
  }

  cancel() {
    this.dialogRef.close();
  }
}
